// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getHome } from '@api';

export const getProbateData = createAsyncThunk('startProbateSlice/getProbateData', async args => {
  const response = await getHome(args);
  return response.data;
})



export const startProbateSlice = createSlice({
  name: 'startprobate',
  initialState: {
    submissionExpiryDays: 90,
    submissionExpiryDate: "",
    isResume: true,
    isPendingAgree: false,
    resumeRoute: 1,
    isDeletable: false,
    hasCaseWithdrawalRequested: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getProbateData.fulfilled, (state, action) => {
        state.submissionExpiryDays= action.payload.submissionExpiryDays ;
        state.submissionExpiryDate= action.payload.submissionExpiryDate ;
        state.isResume = action.payload.isResume;
        state.isPendingAgree= action.payload.isPendingAgree ;
        state.resumeRoute = action.payload.resumeRoute;
        state.isDeletable = action.payload.isDeletable;
        state.hasCaseWithdrawalRequested = action.payload.hasCaseWithdrawalRequested;
      })

  }

})

//export const {} = eligibilityCheckSlice.actions

export default startProbateSlice.reducer

